<template>
    <div class="card">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.questionType.speakParagraph.title') }}</h2>
        </div>
        <div class="card-body d-flex flex-column p-9">
            <div class="fv-row mb-7">
                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.speakParagraph.cols.content') }}</label>
                <el-form-item prop="data.data.content" :rules="$validation.getMessage(['required'])">
                    <CustomCkeditor :model="data.content" @updateModel="data.content = $event"></CustomCkeditor>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.speakParagraph.cols.beforeRecordWaitingSecond') }}</label>
                <el-form-item prop="data.data.options.before_record_waiting_second" :rules="$validation.getMessage(['required'])">
                    <el-input-number v-model="data.options.before_record_waiting_second" :min="1" :max="120"/>
                </el-form-item>
            </div>
            <div class="fv-row mb-7">
                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.speakParagraph.cols.maxRecordSecond') }}</label>
                <el-form-item prop="data.data.options.max_record_second" :rules="$validation.getMessage(['required'])">
                    <el-input-number v-model="data.options.max_record_second" :min="1"/>
                </el-form-item>
            </div>
        </div>
    </div>
</template>

<script>
import CustomCkeditor from "@/components/custom-ckeditor/index.vue";
import md5 from 'md5'

export default {
    name: "SpeakParagraph",
    props: {
        data: Object,
    },
    data() {
        return {
            paragraphPreview: true,
        }
    },
    components: {
        CustomCkeditor
    },
};
</script>
